import React from 'react';
import { AdTypes } from '../../../utils/types';
import styles from '../adWrapper.scss'


const UnitNames = {
    STICKY: 'snack-sticky-manual',
    LEADERBOARD_ONE: 'snack-incontent-slim-2',
    LEADERBOARD_TWO: 'snack-incontent-slim-1',
    RECTANGLE_ONE: 'snack-incontent-1',
    RECTANGLE_TWO: 'snack-incontent-2',
    RECTANGLE_THREE: 'snack-incontent-3',
    WIDE_LEADERBOARD_ONE: 'snack-incontent-slim-3',
    WIDE_LEADERBOARD_TWO: 'snack-incontent-slim-repeater-1',
    SKYSCRAPER_LEFT: 'snack-gutter-left',
    SKYSCRAPER_RIGHT: 'snack-gutter-right',
};

const getUnitName = (unitType) => {
    const { 
        STICKY,
        LEADERBOARD_ONE,
        LEADERBOARD_TWO,
        RECTANGLE_ONE,
        RECTANGLE_TWO,
        RECTANGLE_THREE,
        WIDE_LEADERBOARD_ONE,
        WIDE_LEADERBOARD_TWO,
        SKYSCRAPER_LEFT,
        SKYSCRAPER_RIGHT,
    } = UnitNames;

    switch(unitType) {
        case AdTypes.LEADERBOARD_ONE: {
            return LEADERBOARD_ONE;
        }
        case AdTypes.LEADERBOARD_TWO: {
            return LEADERBOARD_TWO;
        }
        case AdTypes.STICKY: {
            return STICKY;
        }
        case AdTypes.RECTANGLE_ONE: {
            return RECTANGLE_ONE;
        }
        case AdTypes.RECTANGLE_TWO: {
            return RECTANGLE_TWO;
        }
        case AdTypes.RECTANGLE_THREE: {
            return RECTANGLE_THREE;
        }
        case AdTypes.WIDE_LEADERBOARD_ONE: {
            return WIDE_LEADERBOARD_ONE;
        }
        case AdTypes.WIDE_LEADERBOARD_TWO: {
            return WIDE_LEADERBOARD_TWO;
        }
        case AdTypes.SKYSCRAPER_LEFT: {
            return SKYSCRAPER_LEFT;
        }
        case AdTypes.SKYSCRAPER_RIGHT: {
            return SKYSCRAPER_RIGHT;
        }
        default:
            return ''
    }
}

function SnackAdUnit({ unitType }) {
    const unitName = getUnitName(unitType);
    
    return (
        <div id={unitName} className={styles.unitWrapper} />
    );
}

export default SnackAdUnit;